const STORAGE_KEY = "refundManagement_listFilters_v1";

export type RefundSearchFields = {
  bookingId: string;
  userName: string;
  mobileNumber: string;
  vehicleNum: string;
};

export const emptyRefundSearchFields = (): RefundSearchFields => ({
  bookingId: "",
  userName: "",
  mobileNumber: "",
  vehicleNum: "",
});

export type PersistedRefundListFilters = {
  hub: string;
  paymentStatus: string;
  searchFields: RefundSearchFields;
  /** @deprecated use searchFields */
  searchQuery?: string;
  /** @deprecated use rideDateRange */
  rideCompletionDate?: string | null;
  /** [from, to] as YYYY-MM-DD or null — ride start through completion */
  rideDateRange: [string | null, string | null];
  page: number;
  rowsPerPage: number;
};

export function loadRefundListFilters(): PersistedRefundListFilters | null {
  try {
    const raw = sessionStorage.getItem(STORAGE_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw) as Partial<PersistedRefundListFilters> & {
      bookingMasterId?: string;
      username?: string;
      mobileNumber?: string;
      /** @deprecated replaced by refundType */
      paymentStatus?: string;
    };
    if (typeof parsed !== "object" || parsed === null) return null;
    const legacyBookingId =
      typeof parsed.bookingMasterId === "string" ? parsed.bookingMasterId : "";
    const legacyUserName =
      typeof parsed.username === "string" ? parsed.username : "";
    const legacyMobile =
      typeof parsed.mobileNumber === "string" ? parsed.mobileNumber : "";
    const legacySearchQuery =
      typeof parsed.searchQuery === "string" ? parsed.searchQuery : "";

    const searchFieldsRaw = parsed.searchFields;
    const searchFields: RefundSearchFields =
      searchFieldsRaw &&
      typeof searchFieldsRaw === "object" &&
      !Array.isArray(searchFieldsRaw)
        ? {
            bookingId:
              typeof searchFieldsRaw.bookingId === "string"
                ? searchFieldsRaw.bookingId
                : legacyBookingId,
            userName:
              typeof searchFieldsRaw.userName === "string"
                ? searchFieldsRaw.userName
                : legacyUserName || legacySearchQuery,
            mobileNumber:
              typeof searchFieldsRaw.mobileNumber === "string"
                ? searchFieldsRaw.mobileNumber
                : legacyMobile,
            vehicleNum:
              typeof searchFieldsRaw.vehicleNum === "string"
                ? searchFieldsRaw.vehicleNum
                : "",
          }
        : {
            bookingId: legacyBookingId,
            userName: legacyUserName || legacySearchQuery,
            mobileNumber: legacyMobile,
            vehicleNum: "",
          };

    const paymentStatusPersisted =
      typeof parsed.paymentStatus === "string"
        ? parsed.paymentStatus
        : typeof parsed.paymentStatus === "string"
          ? parsed.paymentStatus
          : "";

    return {
      hub: typeof parsed.hub === "string" ? parsed.hub : "",
      paymentStatus: paymentStatusPersisted,
      searchFields,
      rideDateRange: (() => {
        const rawRange = parsed.rideDateRange;
        if (
          Array.isArray(rawRange) &&
          rawRange.length === 2 &&
          (rawRange[0] === null ||
            typeof rawRange[0] === "string") &&
          (rawRange[1] === null ||
            typeof rawRange[1] === "string")
        ) {
          return [rawRange[0], rawRange[1]] as [string | null, string | null];
        }
        const legacy =
          typeof parsed.rideCompletionDate === "string"
            ? parsed.rideCompletionDate
            : null;
        if (legacy) return [legacy, legacy] as [string | null, string | null];
        return [null, null] as [string | null, string | null];
      })(),
      page:
        typeof parsed.page === "number" && Number.isFinite(parsed.page)
          ? Math.max(0, Math.floor(parsed.page))
          : 0,
      rowsPerPage:
        typeof parsed.rowsPerPage === "number" &&
        Number.isFinite(parsed.rowsPerPage)
          ? Math.max(1, Math.floor(parsed.rowsPerPage))
          : 10,
    };
  } catch {
    return null;
  }
}

export function saveRefundListFilters(state: PersistedRefundListFilters): void {
  try {
    sessionStorage.setItem(STORAGE_KEY, JSON.stringify(state));
  } catch {
    // quota / private mode
  }
}
